import { httpClient, ApiResponse, convertModelToFormData } from '@/utils';
import {
  staticBrandsEndpoints,
  IGetBrandsDTO,
  IGetBrandsResponse,
  IUploadBrandDetailsDTO,
  getBrandsEndpoints,
  IUpdateBrandResponse,
} from '@/models/brands.model';

class BrandsAPI {
  static getBrands(params: IGetBrandsDTO): ApiResponse<IGetBrandsResponse> {
    const { GET_BRANDS } = staticBrandsEndpoints;
    return httpClient.get<IGetBrandsResponse>(GET_BRANDS, {
      params,
    });
  }

  static uploadBrandDetails({ id, channelId, ...data }: IUploadBrandDetailsDTO): ApiResponse<IUpdateBrandResponse> {
    const { UPDATE_BRAND } = getBrandsEndpoints({ id });

    const formData = convertModelToFormData(data);

    return httpClient.patch<IUpdateBrandResponse>(UPDATE_BRAND, formData, {
      params: { channelId },
    });
  }
}

export default BrandsAPI;
